import { Output, Socket } from 'rete'

import { CustomConnection } from '../../logic/Connections/CustomConnection'
import { CustomNode } from '../../logic/Nodes'
import { SocketNames } from './SocketsHelper'

export default class CustomOutput extends Output {
  isVisible = true

  declare connections: Array<CustomConnection>
  declare name: SocketNames
  declare node: CustomNode

  isMoved = false

  constructor(key: string, title: string, socket: Socket, multiConns?: boolean) {
    super(key, title, socket, multiConns)

    if (title === SocketNames.Inactive || title === SocketNames.Fail || title === SocketNames.Success) {
      this.isVisible = false
    }
  }

  private _isDisabled = false
  private _isSelected = false

  setIsVisible(val: boolean) :void {
    this.isVisible = val
  }

  get disabled(): boolean {
    return this._isDisabled
  }

  get selected(): boolean {
    return this._isSelected
  }

  get hasConnections(): boolean {
    return this.connections.length > 0
  }

  select(): void {
    this._isSelected = true
  }

  disable(): void {
    this._isDisabled = true
  }

  enable(): void {
    this._isDisabled = false
    this._isSelected = false
  }
}
